import React from 'react';
import Title from '../components/common/Title';

const ContactPage: React.FC = () => {
  return (
    <>
      <Title title="Contact Us" />
      <main>
        <div className="container">
          <div style={{ marginTop: '120px', marginBottom: '50px' }}>
            <h1 className="section-title">Contact Us</h1>
            
            <div style={{ marginTop: '30px' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                <div style={{ flex: '1 1 400px' }}>
                  <div style={{ marginBottom: '30px' }}>
                    <p style={{ marginBottom: '20px', lineHeight: '1.6' }}>
                      Have questions, feedback, or need assistance? We're here to help! Choose the most convenient way to reach us.
                    </p>
                    
                    <div style={{ 
                      background: 'var(--secondary-color)',
                      borderRadius: '8px',
                      padding: '25px',
                      marginBottom: '20px'
                    }}>
                      <h3 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>Customer Support</h3>
                      <p style={{ marginBottom: '10px' }}>For account, billing, or technical issues:</p>
                      <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.8' }}>
                        <li>Email: <a href="mailto:support@quickflick.com" style={{ color: 'var(--primary-color)' }}>support@quickflick.com</a></li>
                        <li>Phone: <a href="tel:+1-800-555-0123" style={{ color: 'var(--primary-color)' }}>1-800-555-0123</a></li>
                        <li>Hours: 24/7 Support</li>
                      </ul>
                      <p>Average response time: Within 24 hours</p>
                    </div>
                    
                    <div style={{ 
                      background: 'var(--secondary-color)',
                      borderRadius: '8px',
                      padding: '25px',
                      marginBottom: '20px'
                    }}>
                      <h3 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>Business Inquiries</h3>
                      <p style={{ marginBottom: '10px' }}>For partnerships, advertising, or business opportunities:</p>
                      <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.8' }}>
                        <li>Email: <a href="mailto:business@quickflick.com" style={{ color: 'var(--primary-color)' }}>business@quickflick.com</a></li>
                        <li>Phone: <a href="tel:+1-800-555-0124" style={{ color: 'var(--primary-color)' }}>1-800-555-0124</a></li>
                        <li>Hours: Monday-Friday, 9 AM - 5 PM (PST)</li>
                      </ul>
                    </div>
                    
                    <div style={{ 
                      background: 'var(--secondary-color)',
                      borderRadius: '8px',
                      padding: '25px'
                    }}>
                      <h3 style={{ color: 'var(--primary-color)', marginBottom: '15px' }}>Content Submissions</h3>
                      <p style={{ marginBottom: '10px' }}>For filmmakers and content creators:</p>
                      <ul style={{ marginLeft: '20px', marginBottom: '15px', lineHeight: '1.8' }}>
                        <li>Email: <a href="mailto:submissions@quickflick.com" style={{ color: 'var(--primary-color)' }}>submissions@quickflick.com</a></li>
                      </ul>
                      <p>Please include a brief description and trailer link in your initial email.</p>
                    </div>
                  </div>
                  
                  <div>
                    <h2 style={{ fontSize: '1.5rem', margin: '30px 0 20px' }}>Visit Our Offices</h2>
                    <div style={{ 
                      background: 'var(--secondary-color)',
                      borderRadius: '8px',
                      padding: '25px',
                      marginBottom: '20px'
                    }}>
                      <h3 style={{ marginBottom: '10px' }}>Headquarters</h3>
                      <address style={{ fontStyle: 'normal', lineHeight: '1.8', marginBottom: '15px' }}>
                        123 Streaming Lane<br />
                        San Francisco, CA 94105<br />
                        United States
                      </address>
                      <p>By appointment only</p>
                    </div>
                  </div>
                </div>
                
                <div style={{ flex: '1 1 450px' }}>
                  <div style={{ 
                    background: 'var(--secondary-color)',
                    borderRadius: '8px',
                    padding: '30px'
                  }}>
                    <h2 style={{ marginBottom: '20px', fontSize: '1.3rem' }}>Send Us a Message</h2>
                    <form>
                      <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px' }}>Name *</label>
                        <input 
                          type="text" 
                          placeholder="Your full name"
                          style={{ 
                            width: '100%',
                            padding: '12px 15px',
                            borderRadius: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            border: 'none',
                            color: 'var(--text-color)'
                          }} 
                          required
                        />
                      </div>
                      
                      <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px' }}>Email *</label>
                        <input 
                          type="email" 
                          placeholder="Your email address"
                          style={{ 
                            width: '100%',
                            padding: '12px 15px',
                            borderRadius: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            border: 'none',
                            color: 'var(--text-color)'
                          }} 
                          required
                        />
                      </div>
                      
                      <div style={{ marginBottom: '15px' }}>
                        <label style={{ display: 'block', marginBottom: '8px' }}>Subject *</label>
                        <select
                          style={{ 
                            width: '100%',
                            padding: '12px 15px',
                            borderRadius: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            border: 'none',
                            color: 'var(--text-color)'
                          }} 
                          required
                        >
                          <option value="" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>Select a subject</option>
                          <option value="account" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>Account Issue</option>
                          <option value="billing" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>Billing Question</option>
                          <option value="technical" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>Technical Support</option>
                          <option value="content" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>Content Request</option>
                          <option value="feedback" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>General Feedback</option>
                          <option value="other" style={{ backgroundColor: 'var(--background-color)', color: 'var(--text-color)' }}>Other</option>
                        </select>
                      </div>
                      
                      <div style={{ marginBottom: '20px' }}>
                        <label style={{ display: 'block', marginBottom: '8px' }}>Message *</label>
                        <textarea 
                          placeholder="How can we help you?"
                          rows={6}
                          style={{ 
                            width: '100%',
                            padding: '12px 15px',
                            borderRadius: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                            border: 'none',
                            color: 'var(--text-color)',
                            resize: 'vertical'
                          }} 
                          required
                        ></textarea>
                      </div>
                      
                      <button className="btn btn-primary" style={{ width: '100%' }}>Send Message</button>
                    </form>
                  </div>
                </div>
              </div>
              
              <div style={{ marginTop: '40px' }}>
                <h2 style={{ fontSize: '1.5rem', margin: '30px 0 20px' }}>Frequently Asked Questions</h2>
                
                <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                  {[
                    {
                      question: 'How do I reset my password?',
                      answer: 'Go to the login page and click on "Forgot Password". Follow the instructions sent to your email to create a new password.'
                    },
                    {
                      question: 'How do I cancel my subscription?',
                      answer: 'You can cancel your subscription at any time by going to Account > Subscription > Cancel Subscription. Your access will continue until the end of your current billing period.'
                    },
                    {
                      question: 'Why is a certain movie or show not available?',
                      answer: 'Content availability may vary based on your region and licensing agreements. You can request content by contacting our support team.'
                    },
                    {
                      question: 'When will you support my device?',
                      answer: 'We\'re constantly expanding our device support. Check our Supported Devices page for updates or contact our support team for specific device inquiries.'
                    }
                  ].map((faq, index) => (
                    <div 
                      key={index}
                      style={{ 
                        background: 'var(--secondary-color)',
                        borderRadius: '8px',
                        padding: '20px'
                      }}
                    >
                      <h3 style={{ marginBottom: '10px' }}>{faq.question}</h3>
                      <p style={{ color: 'var(--light-gray)' }}>{faq.answer}</p>
                    </div>
                  ))}
                </div>
                
                <div style={{ textAlign: 'center', marginTop: '30px' }}>
                  <a href="/faq" className="btn btn-secondary">View All FAQs</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ContactPage; 